import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            isBusy: false,
            selectable: false,
            perPage: 50,
            currentPage: 1,
            rowsMagazzinoListini: 0,
            magazzinoListiniData: [],
            magazzinoListinoData: {},
            filtro: {},
            magazzinoListiniPathResource: "/magazzinolistini",
            magazzinoListiniFields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 2rem",
                },
                {
                    label: "Codice Azienda",
                    key: "codiceAzienda",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Codice",
                    key: "codice",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Tipo calcolo",
                    key: "tipoCalcolo",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Rincaro %",
                    key: "valoreRincaroPercentuale",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Prezzo Soccorso",
                    key: "prezzoSoccorso",
                    sortable: true,
                    thStyle: "width: 2rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadDataMagazzinoListini(afterLoad = null) {
            let me = this;
            this.openShowModalLoading();
            this.filtro = {};
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroListini"]) {
                this.filtro = JSON.parse(sessionStorage["filtroListini"]);
            }
            let link = process.env.VUE_APP_PATH_API + me.magazzinoListiniPathResource;
            axios
                .get(link, { params: this.filtro })
                .then((response) => {
                    this.magazzinoListiniData = response.data.data.list;
                    this.rowsMagazzinoListini = response.data.data.recordsNumber;
                    this.closeShowModalLoading();
                    if (afterLoad) {
                        afterLoad();
                    }
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
    },
};
